import React, { useEffect, useState } from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ShopSalaryConfig from "./components/shopsalaryconfig";
import ShopSalaryRegister2 from "./components/shopsalaryregister2";
import ShopSalaryTotal2 from "./components/shopsalarytotal2";
import HeadOfficeApproval from "./components/headofficeapproval";
import HolidayManagement from "./components/holidaymanagement";
import MockExamManagement from "./components/mockexammanagement";
import TravelAllowanceManagement from "./components/travelallowancemanagement";

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const width = "1500px";

const ShopSalary: React.FC<any> = (props) => {

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <div>
            <div style={{ width: "100%", marginTop: "35px", minWidth : "1500px" }}>
                <Box sx={{ width: "100%", marginBottom: "0px" }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="본인 업무 등록" {...a11yProps(0)} />
                            {
                                (props.user && props.user.todoistApiKey)
                                    ?
                                    <Tab label="전체 업무 관리" {...a11yProps(1)} />
                                    :
                                    ""
                            }
                            {
                                (props.user && props.user.todoistApiKey)
                                    ?
                                    <Tab label="업무 설정 관리" {...a11yProps(2)} />
                                    :
                                    ""
                            }
                            {
                                (props.user && props.user.todoistApiKey)
                                    ?
                                    <Tab label="본사 요청 대타 승인 관리" {...a11yProps(3)} />
                                    :
                                    ""
                            }
                            {
                                (props.user && props.user.todoistApiKey)
                                    ?
                                    <Tab label="공휴일 관리" {...a11yProps(4)} />
                                    :
                                    ""
                            }
                            {
                                (props.user && props.user.todoistApiKey)
                                    ?
                                    <Tab label="모의고사날 설정" {...a11yProps(5)} />
                                    :
                                    ""
                            }
                            {
                                (props.user && props.user.todoistApiKey)
                                    ?
                                    <Tab label="출장비 수정" {...a11yProps(6)} />
                                    :
                                    ""
                            }
                        </Tabs>
                    </Box>
                </Box>
            </div>
            {
                value === 0
                    ?
                    <ShopSalaryRegister2 user={props.user} notify={props.notify} />
                    :
                    ""
            }

            {
                value === 1
                    ?
                    <ShopSalaryTotal2 user={props.user} notify={props.notify} />
                    :
                    ""
            }

            {
                value === 2
                    ?
                    <ShopSalaryConfig user={props.user} notify={props.notify} />
                    :
                    ""
            }

            {
                value === 3
                    ?
                    <HeadOfficeApproval user={props.user} notify={props.notify} />
                    :
                    ""
            }

            {
                value === 4
                    ?
                    <HolidayManagement user={props.user} notify={props.notify} />
                    :
                    ""
            }

            {
                value === 5
                    ?
                    <MockExamManagement user={props.user} notify={props.notify} />
                    :
                    ""
            }

            {
                value === 6
                    ?
                    <TravelAllowanceManagement user={props.user} notify={props.notify} />
                    :
                    ""
            }

        </div>
    )

}

export default ShopSalary;